export enum EDamage {
  // Interior/Exterior Stained
  Mold = 30,
  WaterMark = 4,
  TransferOfColor = 5,
  PenMark = 6,
  Others = 7,
  // Interior/Exterior Smells
  Cigarette = 10,
  Musty = 9,
  OtherSmell = 11,
  Perfume = 8,
  // Interior/Exterior Other Damages
  Cracked = 15,
  Creased = 27,
  CutStitching = 25,
  Discolored = 12,
  LooseStitching = 16,
  OutOfShape = 19,
  Peeling = 14,
  Personalized = 29,
  Powdery = 32,
  Repaired = 28,
  Ripped = 13,
  Split = 26,
  Sticky = 17,
  Worn = 18,
  // Hardware
  Damaged = 21,
  Missing = 24,
  RustyOrTarnished = 23,
  // Hardware/Interior/Exterior
  Scratched = 20,
  Repainted = 31,
}

export enum EDamageLocation {
  // Exterior
  Back = 5,
  Bottom = 6,
  Corners = 9,
  Front = 4,
  HandleOrStrap = 7,
  LeatherOrFabricZipperPull = 29,
  Pocket = 8,
  Side = 10,
  Top = 21,

  // Generic
  Smell = 24,

  // Interior
  InteriorLeatherOrFabricZipperPull = 30,
  InteriorPocket = 12,
  Lining = 11,

  // Hardware
  Closure = 18,
  Embellishment = 22,
  Key = 16,
  PracticalAttachment = 23,
  Zipper = 13,
}

export enum EDamageParent {
  Stains = 1,
  Smells = 2,
  Damages = 3,
}

export enum EDamageSeverityLevel {
  High = "High",
  Low = "Low",
  Medium = "Medium",
}

export enum EDamageParentLocation {
  Exterior = 1,
  Interior = 2,
  Hardware = 3,
}

export type LocationKeys = "exterior" | "generic" | "hardware" | "interior";

export type ExteriorDamageLocationKeys =
  | "back"
  | "bottom"
  | "corners"
  | "front"
  | "handleOrStrap"
  | "leatherOrFabricZipperPull"
  | "pocket"
  | "side"
  | "top";

export type InteriorDamageLocationKeys =
  | "interiorLeatherOrFabricZipperPull"
  | "interiorPocket"
  | "lining";

export type HardwareDamageLocationKeys =
  | "closure"
  | "embellishment"
  | "key"
  | "practicalAttachment"
  | "zipper";

export type DamageLocationKeys =
  | HardwareDamageLocationKeys
  | ExteriorDamageLocationKeys
  | InteriorDamageLocationKeys;

export type HardwareDamageKeys =
  | "damaged"
  | "missing"
  | "repaired"
  | "rustyOrTarnished"
  | "scratched";

export type InteriorExteriorDamageKeys = "otherDamages" | "stained";

export type GenericDamageKeys = "smell";

export type InteriorExteriorDamageOtherDamagesKeys =
  | "cracked"
  | "creased"
  | "cutStitching"
  | "discolored"
  | "looseStitching"
  | "outOfShape"
  | "peeling"
  | "personalized"
  | "powdery"
  | "repainted"
  | "repaired"
  | "ripped"
  | "scratched"
  | "split"
  | "sticky"
  | "worn";

export type GenericDamageSmellKeys =
  | "cigarette"
  | "musty"
  | "others"
  | "perfume";

export type InteriorExteriorDamageSmellKeys =
  | "cigarette"
  | "musty"
  | "others"
  | "perfume";

export type InteriorExteriorDamageStainedKeys =
  | "mold"
  | "others"
  | "penMark"
  | "transferOfColor"
  | "waterMark";

export const genericDamageKeys: GenericDamageKeys[] = ["smell"];

export const exteriorDamageLocationKeys: ExteriorDamageLocationKeys[] = [
  "back",
  "bottom",
  "corners",
  "front",
  "handleOrStrap",
  "leatherOrFabricZipperPull",
  "pocket",
  "side",
  "top",
];

export const hardwareDamageLocationKeys: HardwareDamageLocationKeys[] = [
  "closure",
  "embellishment",
  "key",
  "practicalAttachment",
  "zipper",
];

export const interiorDamageLocationKeys: InteriorDamageLocationKeys[] = [
  "lining",
  "interiorPocket",
  "interiorLeatherOrFabricZipperPull",
];

export const stainedKeys: InteriorExteriorDamageStainedKeys[] = [
  "others",
  "mold",
  "penMark",
  "transferOfColor",
  "waterMark",
];

export const otherDamagesKeys: InteriorExteriorDamageOtherDamagesKeys[] = [
  "cracked",
  "creased",
  "cutStitching",
  "discolored",
  "looseStitching",
  "outOfShape",
  "peeling",
  "personalized",
  "powdery",
  "repainted",
  "repaired",
  "ripped",
  "scratched",
  "split",
  "sticky",
  "worn",
];

export const hardwareKeys: HardwareDamageKeys[] = [
  "damaged",
  "missing",
  "repaired",
  "rustyOrTarnished",
  "scratched",
];

export const genericKeys: GenericDamageSmellKeys[] = [
  "cigarette",
  "musty",
  "others",
  "perfume",
];
